import React, { useEffect } from 'react';
import cn from 'classnames';
import { LogoEvercallHorizontal } from '@dealroadshow/uikit-logo/Evercall/Horizontal';
import { useRouter } from 'next/router';

import { Link, TabLink as NextNavLink } from '@framework/router/Next/Link';
import ContentWrp from '@framework/ui/Templates/ContentWrp';
import Button from '@dealroadshow/uikit-button';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import Header from '@framework/ui/Pages/Landing/Sections/Header';
import SectionFooter from '@framework/ui/Pages/Landing/Sections/Footer';
import useLoginUrlWithConsent from '@framework/cookie-consent/useLoginUrlWithConsent';

import URL from '@evercall/url/urlConstants';
import evercallUrl from '@evercall/url';
import config from '@evercall/config';
import {
  EVERCALL_LANDING_HEADER_MENU,
  EVERCALL_LANDING_FOOTER_CONFIG,
} from './constants';

import stickyFooterStyles from '@framework/ui/Organisms/StickyFooter/stickyFooter.module.scss';
import styles from './layout.module.scss';

interface IProps {
  children: React.ReactNode,
  containerCls?: string,
}

const LandingLayout = ({
  children,
  containerCls,
}: IProps) => {
  const { asPath } = useRouter();
  const loginUrl = useLoginUrlWithConsent(() => evercallUrl.getLoginUrl());

  useEffect(() => {
    const id = asPath.split('#')[1];

    if (id) {
      document.getElementById(id)
        ?.scrollIntoView();
    }
  }, []);

  const pageContainerCls = cn(
    styles.landingPageContainer,
    stickyFooterStyles.pageContainerWithStickyFooter,
    containerCls,
  );

  return (
    <ContentWrp>
      <Header
        logoComponent={ LogoEvercallHorizontal }
        menu={ EVERCALL_LANDING_HEADER_MENU }
        customLoginButton={ ({
          buttonProps,
          linkProps,
        }) => (
          <NextNavLink
            { ...linkProps }
            to={ loginUrl }
          >
            <Button { ...buttonProps } />
          </NextNavLink>
        ) }
        headerButton={ ({ buttonProps }) => (
          <Link to={ URL.SCHEDULE }>
            <Button
              { ...buttonProps }
              title="Schedule Your Event"
              dataTest="scheduleEventButton"
            />
          </Link>
        ) }
        mobileMenuClassName={ styles.mobileMenu }
      />
      <div className={ pageContainerCls }>
        <ScrollBodyBackground tenant={ config.code } />
        { children }
      </div>
      <SectionFooter
        config={ EVERCALL_LANDING_FOOTER_CONFIG }
        contentClassName={ styles.footerContent }
      />
    </ContentWrp>
  );
};

export default LandingLayout;
